import { render, staticRenderFns } from "./Cotizaciones.vue?vue&type=template&id=2e95bca8&scoped=true"
import script from "./Cotizaciones.vue?vue&type=script&lang=js"
export * from "./Cotizaciones.vue?vue&type=script&lang=js"
import style0 from "./Cotizaciones.vue?vue&type=style&index=0&id=2e95bca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e95bca8",
  null
  
)

export default component.exports